module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/index.js
// module id = 2143
// module chunks = 0